import { defineStore } from "pinia";
import { format, subYears } from "date-fns";

export type QuickQuoteCalculatorStore = {
    age: number | null,
    fundValue: number | null,
    postcode: string | null,
}

export const useQuickQuoteCalculatorStore = defineStore("quickQuoteCalculator", {
    state: () : QuickQuoteCalculatorStore => {
        return {
            age: null,
            fundValue: null,
            postcode: null,
        };
    },
    getters: {
        estimatedDateOfBirth(state): string {
            const age = state.age ?? 0;
            const estimatedDateOfBirth = subYears(new Date(), age);
            return format(estimatedDateOfBirth, "yyyy-MM-dd");
        },
    },
});
